export default __webpack_public_path__ + "static/media/IMG_8601.e1ac035b.JPG";